// src/components/chat/ChatToggleButton.tsx
/**
 * ChatToggleButton Component
 * Floating button to open the global AI chat
 */

import { memo } from 'react';
import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useGlobalChat } from '@/contexts/globalChatContext';
import { cn } from '@/lib/utils';
import type { IChatToggleButtonProps } from '@/@types/globalChat';

function ChatToggleButton({ className }: IChatToggleButtonProps) {
  const { isOpen, toggleChat, messages } = useGlobalChat();

  const hasUnread = messages.length > 0;

  return (
    <Button
      onClick={toggleChat}
      size="icon"
      className={cn(
        'fixed bottom-6 right-6 h-14 w-14 rounded-full shadow-lg z-40',
        isOpen && 'bg-muted hover:bg-muted/80',
        className
      )}
    >
      <MessageSquare className="h-6 w-6" />
      {hasUnread && !isOpen && (
        <span className="absolute -top-1 -right-1 h-4 w-4 bg-primary rounded-full" />
      )}
    </Button>
  );
}

const ChatToggleButtonMemo = memo(ChatToggleButton);

export { ChatToggleButtonMemo };
